import React from 'react'
import type { FC } from 'react'
import { useTheme } from '@mui/material'
import { AlertTriangleIcon, ErrorCircleIcon, InfoCircleIcon, SuccessCircleCheckIcon } from '../Icon'
import { SNACKBAR_VARIANTS } from './constants'
import type { DefaultIconProps } from './types'

const VariantIcon: FC<DefaultIconProps> = ({ variant, icon, ...iconProps }) => {
  const { palette } = useTheme()

  if (icon) return <>{icon}</>

  switch (variant) {
    case SNACKBAR_VARIANTS.info:
      return <InfoCircleIcon {...iconProps} color={palette.info.main} />
    case SNACKBAR_VARIANTS.error:
      return <ErrorCircleIcon {...iconProps} color={palette.error.main} />
    case SNACKBAR_VARIANTS.warning:
      return <AlertTriangleIcon {...iconProps} color={palette.warning.main} />
    case SNACKBAR_VARIANTS.success:
      return <SuccessCircleCheckIcon {...iconProps} color={palette.success.main} />
    default:
      return <></>
  }
}

export default VariantIcon
